import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

type Validator = ValidatorFn | null | undefined;
type ComposeValidator = (validators: Validator[]) => ValidatorFn;

export namespace LogicalOperators {
  export const AND: ComposeValidator = Validators.compose as ComposeValidator;

  export const OR: ComposeValidator = (validators: Validator[]): ValidatorFn => {
    return (control: AbstractControl) => {
      let errors: ValidationErrors = {};

      const hasNoErrors: boolean = validators.some((validator: Validator): boolean => {
        if (!validator) {
          return false;
        }

        const validatorResult: ValidationErrors | null = validator(control);

        if (validatorResult) {
          errors = {...errors, ...validatorResult};
        }

        return !validatorResult;
      });

      return hasNoErrors ? null : errors;
    };
  };
}
